/* Component Dependencies */
var agreeAndSubmitTemplate = require('templates/agreeAndSubmit.hbs');
var marketingConsentForKRAgreeAndSubmitTemplate = require('templates/agreeAndSubmit-marketingConsentForKR.hbs');
var joinAndCancelTemplate = require('templates/joinAndCancel.hbs');
var joinAndCancelOcjTemplate = require('templates/joinAndCancel-ocj.hbs');
var AriesComponent = require('libs/aries-component');
var DateHandler = require('libs/date-handler');
var PubSub = require('libs/pub-sub');


PubSub.register(AriesComponent.extend({
  type: 'agreeAndSubmit',

  template: {
    'agreeAndSubmit': agreeAndSubmitTemplate,
    'marketingConsentForKRAgreeAndSubmit': marketingConsentForKRAgreeAndSubmitTemplate,
    'joinAndCancel' : joinAndCancelTemplate,
    'joinAndCancel-ocj' : joinAndCancelOcjTemplate
  },

  subscribe: {
    'TOGGLE_VISIBLE_SUBMIT_CLEAR': 'toggleVisible',
    'CN_LOCALE_MOBILE':'isCnLocaleAndMobileVerification'
  },

  events: {
    'click .js-reset-btn': 'formResetHandler',
    'click .js-submit-button': 'submitEnrollmentForm'
  },

  bindEvents: function () {
    var _self = this;
    _self.isCnLocaleVal = $('input[name="isCnLocale"]').val();
    _self.isEnrollEnable = $(".tile-country-consent").attr("data-isEnrollEnable");
    if ($('.tile-agree-and-submit').length) {
      var $form = window.$(this.$el.find('.submit-button')[0].form);
      $form.on('submit', this.formSubmitHandler.bind(this));
    }
  
    if ($('.js-agree-button').length) {
      $('.js-agree-button').on('click', this.iAgreeBtnConsentHandler.bind(this));
    }
    
    var cnSelected = $('#isChinaCountrySelected').val();
    var krSelected = $('#isSKCountrySelected').val();
      if((cnSelected !== 'true') && (krSelected !== 'true') && (_self.isCnLocaleVal === 'true' &&  _self.isCnLocaleVal != undefined) && (_self.isEnrollEnable === 'true' &&  _self.isEnrollEnable != undefined)){
      $('.js-submit-button').prop('disabled', true);
    }
  },
  
  isCnLocaleAndMobileVerification: function(rfpFlowVal,irfpFlowVal,isCnLocaleVal,isMobileVerificationRequiredVal,isModalsQueryParam){
    var context = {
      rfpFlow: rfpFlowVal,
      irfpFlow: irfpFlowVal,
      isCnLocaleVal: isCnLocaleVal,
      isMobileVerificationRequiredVal: isMobileVerificationRequiredVal,
      isModalsQueryParam: isModalsQueryParam
    }
    this.refresh(context);
  },
  
  formSubmitHandler: function() {
    this.$el.find('button').prop('disabled', true);
  },

  formResetHandler: function(event) {
    this.pubsub.publish('CONTACT_US_CLEAR_FORM');
  },

  submitEnrollmentForm: function(event) {
    var selectedCheckbox = $('.js-select-consent,.js-select-all-consents');
    var checkBoxArr = [];
    for(let i=0; i<selectedCheckbox.length; i++){
      selectedCheckbox[i].checked && checkBoxArr.push({[selectedCheckbox[i]["name"]]:  selectedCheckbox[i].value });
   }
    this.pubsub.publish('SUBMIT_ENROLL_FORM', [checkBoxArr]);
  },

  toggleVisible: function(data) {
    var visible = data.visible;
    visible ? this.$el.removeClass('is-hidden') : this.$el.addClass('is-hidden'); 
  },
  
  /**
   * This function is used to check the checkbox of the terms link clicked
   * in guestinfo.mi page for korean users and standlone enrollment
   */
  iAgreeBtnConsentHandler: function(){
    var _self = this;
    var agreeAllConsent = $('#agree-all-consent, #consent-all, .js-select-all-consents');
    $('.checkbox-popup-triggered').filter(':visible').prop('checked', true);
    
    //if length of checkbox checked equal to all the check box checked then check agree all consent
    var consentCheckboxes = $('.js-select-consent');
    if (consentCheckboxes.length > 0) {
      if(consentCheckboxes.filter(':visible').filter(':checked').length === consentCheckboxes.filter(':visible').length) {
        agreeAllConsent.filter(':visible').prop('checked', true);
        this.pubsub.publish('CHECK_AGREE_ALL', []);
      }
    }

    /*On Click of Terms link for SK country checkbox check/uncheck functionality */
    $('.checkbox-popup-triggered').filter(':visible').removeClass('checkbox-popup-triggered');    
    this.pubsub.publish('POPUP_CLOSE');
    _self.isCnLocaleVal === "true" && this.pubsub.publish('TOGGLE_JOIN_BTN');
  }
  
}));